import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/shared/components'
import { ActivityTypesPage } from '@/pages/activity-types/ActivityTypesPage'

export const Route = createFileRoute('/activity-types')({
  component: () => (
    <RequirePermission section="dictionaries" action="view">
      <ActivityTypesPage />
    </RequirePermission>
  ),
})
